import React, { Dispatch, SetStateAction } from "react";

type TransparentDivContext = {
  isTransparentDivDisplayed: boolean;
  setIsTransparentDivDisplayed: Dispatch<SetStateAction<boolean>>;
};

export default React.createContext<TransparentDivContext>({
  isTransparentDivDisplayed: false,
  setIsTransparentDivDisplayed: (value) => {},
});
